// extracted by mini-css-extract-plugin
export default {"container":"_842c15be"};